const SHAPE_TEXT_TYPE = 'shapeTextType'
const SHAPE_SPECIFIC_TEXT = 'shapeSpecificText'
const SHAPE_TEXT_PROPERTY = 'shapeTextProperty'

const SHAPE_COLOR_TYPE = 'shapeColorType'
const SHAPE_SPECIFIC_COLOR = 'shapeSpecificColor'

const DEFAULT_SHAPE_COLOR = 'blue-medium'

const SHAPE_TEXT_BOLD = 'shapeTextBold'
const SHAPE_TEXT_ITALIC = 'shapeTextItalic'
const SHAPE_TEXT_UNDERLINE = 'shapeTextUnderline'

const HANDLES = 'handles'
const TIP_SIZE = 'tipSize'

const SHAPE_TEXT_ROTATION = 'shapeTextRotation'

const SHAPE_TEXT_ROTATION_AUTO = 'auto'

const SHAPE_OPACITY = 'shapeOpacity'

const SHAPE = 'shape'
const SHAPE_HEIGHT = 'shapeHeight'
const FILL = 'fill'

const DATA_SOURCE_PROPERTY = 'dataSourceProperty'

export { SHAPE_TEXT_TYPE, SHAPE_SPECIFIC_TEXT, SHAPE_TEXT_PROPERTY,
	SHAPE_COLOR_TYPE, SHAPE_SPECIFIC_COLOR, DEFAULT_SHAPE_COLOR,
	SHAPE_TEXT_BOLD, SHAPE_TEXT_ITALIC, SHAPE_TEXT_UNDERLINE,
	HANDLES, TIP_SIZE, SHAPE_TEXT_ROTATION, SHAPE_TEXT_ROTATION_AUTO,
	SHAPE_OPACITY, SHAPE, SHAPE_HEIGHT, FILL, DATA_SOURCE_PROPERTY }
